import React from 'react';
import './Loading1.css';

function Loading1() {
    return (
        <div className="loading-wrapper">
            <div className="loader"></div>
            <label className="loading-text">Loading...</label>
        </div>
    );
}

export default Loading1;